var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { observable, action, runInAction } from "mobx";
import http, { Q, Api } from "@common/utils/http";
var RequestStore = /** @class */ (function () {
    function RequestStore() {
        this.woDetail = {};
        this.availableDate = {};
        this.currentWOId = null;
        this.currentWOType = false;
    }
    RequestStore.prototype.getWoDetail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getWoDetail(this.currentWOId, this.currentWOType);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.woDetail = data;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    RequestStore.prototype.getAvailableDate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getAvailableDate(this.currentWOId);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.availableDate = data;
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    RequestStore.prototype.updateEntryInfo = function (entryInfo, version) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api().updateEntryInfo(this.currentWOId, this.currentWOType, entryInfo, version)];
            });
        });
    };
    RequestStore.prototype.updateCurrentWO = function (id, isReactive) {
        this.currentWOId = id;
        this.currentWOType = isReactive;
    };
    RequestStore.prototype.clear = function () {
        this.woDetail = {};
        this.availableDate = {};
    };
    RequestStore.prototype.api = function () {
        return {
            getWoDetail: function (id, isReactive) {
                var url = isReactive ? 'Request' : 'Recurring';
                return Q(http.post("/RSP/" + url + "/" + id + "/WoDetail"));
            },
            getAvailableDate: function (id) {
                return Q(http.post("/RSP/Request/" + id + "/GetAvailableDate"));
            },
            updateEntryInfo: function (id, isReactive, entryInfo, version) {
                var url = isReactive ? 'Request' : 'Recurring';
                return Q(http.post("/RSP/" + url + "/" + id + "/UpdateEntryInfo", { value: entryInfo, version: version }, __assign(__assign({}, Api.withForm), Api.cancelRepsoneAutoParse)));
            }
        };
    };
    __decorate([
        observable
    ], RequestStore.prototype, "woDetail", void 0);
    __decorate([
        observable
    ], RequestStore.prototype, "availableDate", void 0);
    __decorate([
        action
    ], RequestStore.prototype, "getWoDetail", null);
    __decorate([
        action
    ], RequestStore.prototype, "getAvailableDate", null);
    __decorate([
        action
    ], RequestStore.prototype, "updateEntryInfo", null);
    __decorate([
        action
    ], RequestStore.prototype, "clear", null);
    return RequestStore;
}());
export default RequestStore;
